// This file is auto-generated by the "tsproxygen.exe" tool. Manual modification is not recommended.
import type TimeZoneDefinitionType from '../contract/TimeZoneDefinitionType';

export default function timeZoneDefinitionType(
    data: TimeZoneDefinitionType
): TimeZoneDefinitionType {
    const result: TimeZoneDefinitionType = {
        __type: 'TimeZoneDefinitionType:#Exchange',
        ...data,
    };

    return result;
}
